export const pendingStatuses = [
  'PENDING',
  'PENDING_BRAND_RETRY',
  'PENDING_DCA_COMPLETE',
  'SOLE_PROPRIETOR',
];
export const submittedStatuses = ['NOT_SUBMITTED', 'NOT_STARTED', 'DECLINED'];
